import { LandingV2Scene } from './scene';

export default function LandingV2() {
  return <LandingV2Scene />;
}
